const USER_UPDATE = 'app/USER/UPDATE';
const META_UPDATE = 'app/META/UPDATE';
const CURRENCIES_UPDATE = 'app/CURRENCIES/UPDATE';

export {
  USER_UPDATE,
  META_UPDATE,
  CURRENCIES_UPDATE
}